import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

const SuperUserProtectedRoute = () => {
  const { isAuthenticated, isVerified } = useAuth();
  const user = JSON.parse(localStorage.getItem("user") || "null");

  if (!isAuthenticated) {
    return <Navigate to="/v2/auth/login" replace />;
  }

  if (!isVerified) {
    return <Navigate to="/v2/auth/verify-email-sent" replace />;
  }

  if (!user?.is_superadmin) {
    return <Navigate to="/v2" replace />;
  }

  return <Outlet />;
};

export default SuperUserProtectedRoute;
